var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5689: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9427), __webpack_require__.e(8146), __webpack_require__.e(3705), __webpack_require__.e(2076), __webpack_require__.e(5699)]).then(() => (() => (__webpack_require__(5699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",
	},
	9427: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(1340)]).then(() => (() => (__webpack_require__(1340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",
	},
	7591: {
		fallback: () => (Promise.all([__webpack_require__.e(9427), __webpack_require__.e(7610)]).then(() => (() => (__webpack_require__(7610))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",
	},
	3561: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(2076), __webpack_require__.e(3868)]).then(() => (() => (__webpack_require__(2945))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/app",
	},
	1222: {
		fallback: () => (Promise.all([__webpack_require__.e(307), __webpack_require__.e(2190), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",
	},
	6587: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(4729), __webpack_require__.e(7484)]).then(() => (() => (__webpack_require__(7484))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/auth",
	},
	307: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9427), __webpack_require__.e(8015)]).then(() => (() => (__webpack_require__(8015))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",
	},
	325: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(4456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",
	},
	7843: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(1222), __webpack_require__.e(6039)]).then(() => (() => (__webpack_require__(6039))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",
	},
	993: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(4729), __webpack_require__.e(6841)]).then(() => (() => (__webpack_require__(6841))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/storage",
	},
	3757: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(4729), __webpack_require__.e(4786)]).then(() => (() => (__webpack_require__(4786))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/firestore",
	},
	4803: {
		fallback: () => (__webpack_require__.e(9645).then(() => (() => (__webpack_require__(9645))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.11.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",
	},
	7020: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(1222), __webpack_require__.e(307), __webpack_require__.e(9980), __webpack_require__.e(5969)]).then(() => (() => (__webpack_require__(5969))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@pathos/pathoslogos-ui",
	},
	7250: {
		fallback: () => (__webpack_require__.e(6227).then(() => (() => (__webpack_require__(6227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.17.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",
	},
	7337: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(8859), __webpack_require__.e(4729), __webpack_require__.e(7636)]).then(() => (() => (__webpack_require__(7636))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/functions",
	},
	8000: {
		fallback: () => (Promise.all([__webpack_require__.e(9980), __webpack_require__.e(5424)]).then(() => (() => (__webpack_require__(5424))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@core-my-number/shared",
	},
	9425: {
		fallback: () => (Promise.all([__webpack_require__.e(2190), __webpack_require__.e(6091), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(3835))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",
	},
	7399: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(3620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",
	},
	2799: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(2867))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",
	},
	9515: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8070))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",
	},
	8859: {
		fallback: () => (Promise.all([__webpack_require__.e(3985), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(2531))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire",
	},
	4729: {
		fallback: () => (Promise.all([__webpack_require__.e(7591), __webpack_require__.e(179)]).then(() => (() => (__webpack_require__(179))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/app-check",
	},
	3985: {
		fallback: () => (Promise.all([__webpack_require__.e(8146), __webpack_require__.e(3705), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(9074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",
	},
	6091: {
		fallback: () => (Promise.all([__webpack_require__.e(1351), __webpack_require__.e(1147)]).then(() => (() => (__webpack_require__(1147))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",
	},
	9980: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(4319), __webpack_require__.e(9168), __webpack_require__.e(20), __webpack_require__.e(5303), __webpack_require__.e(6882), __webpack_require__.e(3482)]).then(() => (() => (__webpack_require__(3482))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/dialog",
	},
	2087: {
		fallback: () => (__webpack_require__.e(5841).then(() => (() => (__webpack_require__(5841))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "file-saver",
	},
	2455: {
		fallback: () => (__webpack_require__.e(8317).then(() => (() => (__webpack_require__(8317))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "encoding-japanese",
	},
	6192: {
		fallback: () => (__webpack_require__.e(5696).then(() => (() => (__webpack_require__(5696))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.15.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	},
	2658: {
		fallback: () => (Promise.all([__webpack_require__.e(4319), __webpack_require__.e(9168), __webpack_require__.e(20), __webpack_require__.e(5303), __webpack_require__.e(3164)]).then(() => (() => (__webpack_require__(3164))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/menu",
	},
	4453: {
		fallback: () => (Promise.all([__webpack_require__.e(1351), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(7172))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.17",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations",
	},
	4876: {
		fallback: () => (Promise.all([__webpack_require__.e(5303), __webpack_require__.e(6882), __webpack_require__.e(8478)]).then(() => (() => (__webpack_require__(1005))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",
	},
	6228: {
		fallback: () => (Promise.all([__webpack_require__.e(4319), __webpack_require__.e(9168), __webpack_require__.e(20), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(1570))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",
	},
	9404: {
		fallback: () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(9168))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",
	},
	9520: {
		fallback: () => (__webpack_require__.e(4319).then(() => (() => (__webpack_require__(4319))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"307": [
		307
	],
	"479": [
		325,
		7843
	],
	"1222": [
		1222
	],
	"2234": [
		8000,
		9425
	],
	"3561": [
		3561
	],
	"3705": [
		2799,
		9515
	],
	"3985": [
		3985
	],
	"4729": [
		4729
	],
	"5424": [
		2087,
		2455,
		6192
	],
	"5689": [
		5689
	],
	"5969": [
		2658,
		4453,
		4876,
		6228,
		9404,
		9520
	],
	"6091": [
		6091
	],
	"6587": [
		6587
	],
	"7399": [
		7399
	],
	"7591": [
		7591
	],
	"8859": [
		8859
	],
	"9427": [
		9427
	],
	"9908": [
		993,
		3757,
		4803,
		7020,
		7250,
		7337
	],
	"9980": [
		9980
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}